import { FC } from 'react'
import MainCard from 'ui-component/cards/MainCard'

interface BritamAdminSupportProps {}

export const BritamAdminSupport: FC<BritamAdminSupportProps> = () => {
  return (
    <MainCard>BritamAdminSupport</MainCard>
  )
}
